import StoreNewEditForm from '../components/store-new-edit-form';

// ----------------------------------------------------------------------

export default function CreateStore() {
  return <StoreNewEditForm />;
}
